import React, { useEffect, useState } from "react";
import { LOGO_URL } from "../constants/site";

export const Loader = () => {
  const [done, setDone] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setDone(true), 900);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      data-testid="aw-loader"
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center bg-white transition-opacity duration-700 ${
        done ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
    >
      <div className="aw-loader-logo w-24 h-24 md:w-28 md:h-28">
        <img src={LOGO_URL} alt="Alpha Watch" className="w-full h-full object-contain" />
      </div>
      <div className="mt-10 w-40 h-px bg-black/20 overflow-hidden">
        <div className="aw-loader-line h-full w-full bg-black" />
      </div>
      <p className="mt-6 font-sans-aw text-[10px] tracking-luxury uppercase text-black/50">
        Alpha Watch · Zürich
      </p>
    </div>
  );
};
